import React from 'react';
import type { Nullable } from 'corgi-types';

import { Flex } from 'common/components/Flex';
import { RenderingType } from '../../../../product-mvc-buttons/components/enums';
import { useLocalization } from '../../../providers/LocaleProvider';
import { CaptionRegularCR2 } from '../../Typography';
import type { ProductListVariation, TrackingContext } from '../types/types';
import VariationButton from '../VariationButtonV2';

interface ProductVariationsV2Props {
  sku: string;
  variations: ProductListVariation[];
  url: string;
  minPrice: Nullable<number>;
  trackingContext: TrackingContext;
}

const hasVariations = (variations: ProductListVariation[]) =>
  variations?.some(variation => variation.renderingType === RenderingType.Icon);

const ProductVariations = ({
  sku,
  variations,
  url,
  minPrice,
  trackingContext,
}: ProductVariationsV2Props) => {
  const { t, fc } = useLocalization();

  if (!hasVariations(variations) && !minPrice) {
    return null;
  }

  return (
    <Flex
      gap={['sp_4', null, null, 'sp_6']}
      mb={['sp_4', null, null, 'sp_6']}
      flexWrap="wrap"
      alignItems={['center', null, null, 'center']}
    >
      <VariationButton
        sku={sku}
        url={url}
        variations={variations}
        trackingContext={trackingContext}
      />
      {minPrice && (
        <CaptionRegularCR2 color="sys.neutral.text.default" whiteSpace="nowrap">
          {t('h24_more_variations_from')} {fc(minPrice)}
        </CaptionRegularCR2>
      )}
    </Flex>
  );
};

export default ProductVariations;
